import styled from '@emotion/styled';
import Divider from '@portalterreno/react-ui-core/Divider';
import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import StyledIconContent from '../PropertyCardCyber/StyledIconContent';
import CampaignDiscount, { CampaignDiscountProps } from './CampaignDiscount';
import SubContentWrapper from './SubContentWrapper';
import Wrapper from './Wrapper';

export type CampaignSubContentProps = Pick<CampaignDiscountProps, 'logo'> & {
  name: string;
  campaignDescription?: string;
  campaignDiscountText?: string;
};

const IconContent = styled(StyledIconContent)({
  width: '22px',
  height: '22px'
});

const TitleWrapper = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const CampaignSubContent: React.FC<CampaignSubContentProps> = ({
  name,
  logo,
  campaignDescription,
  campaignDiscountText
}) => {
  return (
    <Wrapper>
      <Divider />
      <SubContentWrapper>
        <TitleWrapper>
          <IconContent />
          <Typography
            variant='subtitle2'
            weight='semibold'
            as='h2'
            style={{ marginBottom: '0px' }}
          >
            {name}
          </Typography>
        </TitleWrapper>
      </SubContentWrapper>
      {campaignDiscountText && (
        <CampaignDiscount
          logo={logo}
          campaignDiscountText={campaignDiscountText}
        />
      )}
      {campaignDescription && (
        <Typography
          as='div'
          variant='body1'
          weight='regular'
          dangerouslySetInnerHTML={{
            __html: campaignDescription
          }}
        />
      )}
    </Wrapper>
  );
};

export default CampaignSubContent;
